import React, { Component } from 'react';
import PropTypes from 'prop-types';
import inView from 'in-view';
import 'odometer/themes/odometer-theme-default.css';
import './Odometer.scss';

class OdometerComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: 0,
    };
  }

  componentDidMount() {
    // Odometer plugin is not adapted to Gatsby HTML build stage
    // require allow to build HTML without @'document not defined' issue
    this.Odometer = require('react-odometerjs');

    inView(`#${this.props.uniqueID}`).on('enter', el => {
      el.classList.add('is-inview');
      this.setState({ value: this.props.value });
    });
  }

  render() {
    const { value } = this.state;
    const { uniqueID } = this.props;

    return (
      <div id={uniqueID} className={'odometer__container'}>
        {this.Odometer && <this.Odometer.default format={'d'} value={value} />}
      </div>
    );
  }
}

OdometerComponent.propTypes = {
  uniqueID: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
};

export default OdometerComponent;
